





































import { Component, Prop, Ref, PropSync, Emit } from 'nuxt-property-decorator'
import { ComponentVue } from '@/base'
import { ModalAuthorityPublisherHelp } from '@/components/modals/ModalAuthorityPublisherHelp'
import { AtomTextField } from '@/components/atoms'
import { AuthorityItem } from '@/types'

@Component({
  components: {
    ModalAuthorityPublisherHelp
  }
})
export default class InputPublisher extends ComponentVue {
  @Ref()
  textField!: AtomTextField

  @Ref()
  modalHelp!: ModalAuthorityPublisherHelp

  @Prop({ type: String })
  placeholder!: string

  @Prop({ type: Boolean })
  disabled!: boolean

  @Prop({
    type: String
  })
  maxlength!: string

  @PropSync('input', {
    type: String,
    required: true
  })
  internalInput!: string

  @PropSync('id', {
    type: String,
    required: true
  })
  internalId!: string

  @PropSync('errorMessage', {
    type: String,
    required: true
  })
  internalErrorMessage!: string

  get iconColor(): string {
    return this.internalInput ? '#4769CB' : ''
  }

  onClickHelp() {
    if (this.internalInput.length > 0) {
      this.textField.atomTextField.blur()
      this.modalHelp.open()
    }
  }

  onInput() {
    this.internalId = ''
    this.internalErrorMessage = ''
    this.$emit('input', this.internalInput)
  }

  onInputAuthority(item: AuthorityItem | null) {
    if (item === null) return
    this.internalInput = item.display
    this.internalId = item.authorityNo
    this.internalErrorMessage = ''

    this.$emit('input:authority', item)
  }

  @Emit('keydown:enter')
  onKeydownEnter() {}
}
